import React from 'react'
import pageBannerStyles from './styles.module.scss'
// import ButtonPrimary from '../button/buttonPrimary'
// import ButtonSecondary from '../button/buttonSecondary'

const PageBanner = ({ pageTitle, pageShortDescription }) => {
  return (
    <section className={pageBannerStyles.bannerSection}>
      <div className={pageBannerStyles.container}>
        <div>
          <div>
            <h1 className={pageBannerStyles.bannerTitle}>{pageTitle}</h1>
            <div className={pageBannerStyles.bannerDescription}>
              {pageShortDescription}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default PageBanner
